import { useQuery } from "@tanstack/react-query";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getRequest } from "../../services/apiMethods";
import moment from "moment";

const Employees = () => {
  const Navigate = useNavigate();

  const { data: EmployeesData, error: userError, isLoading: userLoading } = useQuery({
    queryKey: ["EmployeesData"],
    queryFn: () => getRequest(`/employee/list`),
  });

  // If loading, display loading state
  if (userLoading) {
    return <div>Loading...</div>;
  }

  // If there is an error, display an error message
  if (userError) {
    return <div>Error: {userError.message}</div>;
  }

  return (
    <div className="my-profile-box-contain">
      <div className="my-profile-box-form">
        <div className="h-100 m-0">
          <div className="form-box-title d-flex justify-content-between">
            <div>
              <h4>Employees</h4>
              <p>
                Adding employees is optional but could
                help you secure more business
                <br /> by building trust with your
                clients
              </p>
            </div>
            <button
              className="theme-comm-btn"
              onClick={() => Navigate("/employee")}
            >
              Add
            </button>
          </div>
          <div className="portfolio-card-contain">
            <Row>
              {Array.isArray(EmployeesData?.data) && EmployeesData?.data.length > 0 ? (
                EmployeesData?.data.map((val, index) => (
                  <Col lg={3} key={index} onClick={() =>
                    Navigate(`/employee?employeeId=${val?._id}`)
                  } 
                  style={{cursor:"pointer"}}
                  >
                    <div className="portfolio-card-box portfolio-card-employees">
                      <img
                        src={ val?.image ? val?.image :require("../../assets/images/vector-logo.svg").default}
                        alt="Employee"
                      />
                      <h4 className="text-center">{val?.employeeName}</h4>
                      {/* <p className="text-center">
                        {val?.jobRole}
                        <br /> Since {moment(`${val?.joiningDate}`).format("MMM YYYY")}
                      </p> */}
                    </div>
                  </Col>
                ))
              ) : (
                <Col lg={12}>
                  <div className="text-center">
                    {/* <h4>No data found</h4> */}
                  </div>
                </Col>
              )}
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Employees;
